<!-- style="margin-bottom: 2vh; background-color: var(--ck-color-focus-border); text-align: center; width: 100%; justify-content: center; font-size: 1em !important; height: 5vh; color: whitesmoke;" > -->


<form [formGroup]="addStepForm" class="form">
    <!--     <mat-selection-list class="form__select-step"  placeholder="Выберите тип этапа"  [formControl]="stepControl" >
          @for (step of stepModel | keyvalue; track step.key) {
            <mat-list-option (click)="changeStep(step)"
              class="form__select-step__item"
              [value]="step.key"
              [class.form__select-step__item-selected]="step.value.selected"
              [class.form__select-step__item-unselected]="!step.value.selected"
              [style.background-color]="step.value.color">
              <span class="form__select-step__item__elements">
                <button mat-raised-button [style.background-color]="step.value.color" style="opacity: 1 !important; border: 1px solid grey; margin-bottom: ; ">
                  <img [src]="step.value.icon" alt="" >
                  {{step.value.title | translate|titlecase }}

                </button>
                <span class="added-steps" *ngIf="newSteps.get(step.key).length" style="display: inline-flex; margin-left: 2vw;">
                  <mat-chip-listbox aria-label="Cutest dog breeds" style="display: inline-flex; height: 100%;">
                    @for (stepAdded of newSteps.get(step.key); track stepAdded) {
                      <mat-chip-option style="display: inline-flex;"
                      (click)="
                      removeStep($event,stepAdded,newSteps.get(step.key),step)"> {{stepAdded}}</mat-chip-option>
                     }
                  </mat-chip-listbox>

                        </span>
              </span>
            </mat-list-option>
          }
        </mat-selection-list> -->

    @for (step of stepModel | keyvalue; track step.key) {
        <button mat-raised-button (click)="changeStep(step)"
                class="form__step"
                style="color: black !important;"
                [value]="step.key"
                [class.form__step-selected]="step.value.selected"
                [class.form__step-unselected]="!step.value.selected"
                [style.background-color]="step.value.color">
          <span class="form__step__item">
            <span class="form__step__item__title">
              <img [src]="step.value.icon" alt="">
                {{ step.value.title | translate|titlecase }}
            </span>
            <span class="form__step__item__new-ones" *ngIf="newSteps.get(step.key).length">
              <mat-chip-listbox aria-label="Cutest dog breeds" style="display: inline-flex;">
                @for (stepAdded of newSteps.get(step.key); track stepAdded) {
                    <!--                   <mat-chip-option style="display: inline-flex;"
                                      (click)="removeStep($event,stepAdded,newSteps.get(step.key),step)">
                                      {{stepAdded}}
                                      </mat-chip-option>  -->
                }
              </mat-chip-listbox>
            </span>
          </span>
        </button>
    }
    <!--   <div class="form__buttons-block">
      <button mat-flat-button
        (click)="saveStep()"
        color="secondary"
        >
        Добавить
      </button>
      <button mat-flat-button
        (click)="cancelStep()"
        color="warn">
        Отменить
      </button>
    </div> -->
</form>
<!-- <mat-toolbar cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" style="background-color: gray; opacity: 0.3;" >
  </mat-toolbar> -->